import React from "react";
import { Link } from "react-router-dom";
import { PRACTICE_AREAS } from "../../data/practiceAreas";

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="max-w-content mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Column 1 */}
          <div>
            <div className="text-lg font-extrabold mb-3">
              LegalConnect<span className="text-gold">360</span>
            </div>
            <p className="text-white/70 text-sm max-w-xs">
              Exclusive, consent-documented legal leads delivered in real time
              to law firms and professional practices across seven practice
              areas.
            </p>
            <div className="mt-4 space-y-1 text-sm">
              <a href="tel:+19842612925" className="block text-white/70 hover:text-gold transition-colors" data-testid="footer-phone">
                984-261-2925
              </a>
              <a href="mailto:admin@legalconnect360.com" className="block text-white/70 hover:text-gold transition-colors" data-testid="footer-email">
                admin@legalconnect360.com
              </a>
            </div>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-white text-sm font-semibold uppercase tracking-wide mb-4">
              Practice Areas
            </h4>
            <ul className="space-y-2">
              {PRACTICE_AREAS.map((area) => (
                <li key={area.slug}>
                  <Link
                    to={`/${area.slug}`}
                    className="text-white/70 text-sm hover:text-gold transition-colors"
                    data-testid={`footer-area-${area.slug}`}
                  >
                    {area.navName}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-white text-sm font-semibold uppercase tracking-wide mb-4">
              Company
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/#how-it-works" className="text-white/70 text-sm hover:text-gold transition-colors" data-testid="footer-how-it-works">
                  How It Works
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-white/70 text-sm hover:text-gold transition-colors" data-testid="footer-faq">
                  FAQ
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 text-sm hover:text-gold transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 mt-10 pt-6">
          <p className="text-white/50 text-xs leading-relaxed" data-testid="footer-legal">
            © 2026 LegalConnect360. All rights reserved. LegalConnect360 is a
            legal lead generation and marketing company, not a law firm, lawyer
            referral service, or prepaid legal services plan, and does not
            provide legal advice. Use of this site does not create an
            attorney-client relationship.
          </p>
        </div>
      </div>
    </footer>
  );
}
